import { Link } from "react-router-dom";

import { ClinicalStudies } from "../../api";
import { clinicalStudies } from "../../constants/enum-to-text";

export function StudiesListRoute() {
  return (
    <ul className="list-disc pl-5">
      {Object.values(ClinicalStudies).map((study) => (
        <li key={study}>
          <Link to={study}>{clinicalStudies[study]}</Link>
        </li>
      ))}
    </ul>
  );
}
